import React from 'react';
import CreateOrChangeTariffFeatureForm from '../../features/tariff/CreateOrChangeTariffFeatureForm';
import {
  useCreateNewTariffFeatureMutation,
  useGetTariffByIdQuery,
} from '../../features/tariff/tariff.service';
import { NewTariffFeature } from '../../features/tariff/tariff.types';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import routes from '../../routes';
import { isFetchBaseQueryError } from '../../utils/helpers';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import cls from './NewTariffFeaturePage.module.scss';
import Breadcrumbs from '../../UIComponents/Breadcrumbs';
const NewTariffFeaturePage = () => {
  const { tariffId } = useParams();

  const navigate = useNavigate();
  const [createNewFeature] = useCreateNewTariffFeatureMutation();
  const { data: tariff } = useGetTariffByIdQuery(tariffId as string);
  const createFeatureHandler = async (feature: NewTariffFeature) => {
    console.log('feature');
    try {
      await createNewFeature({ feature: feature, tariffId: tariffId as string }).unwrap();
      toast.success('Feature created successfully');
      navigate(routes.pages.tariffPageById(tariffId as string));
    } catch (error) {
      if (isFetchBaseQueryError(error)) {
        if (error.status === 404) toast.error('Tariff not found');
        if (error.status === 422) toast.error('Failed to add new feature');
        if (error.status === 401) toast.error('Please try again later');
      }
    }
  };
  useDocumentTitle('Create new feature');
  return (
    <div data-testid="new-tariff-feature" className={`${cls.Container} grid-container`}>
      <Breadcrumbs
        elements={[
          { name: 'Tariffs', link: routes.pages.tariffsPage(), active: false },
          {
            name: tariff?.name ?? '',
            link: routes.pages.tariffPageById(tariffId ?? ''),
            active: false,
          },
          { name: 'Add feature', link: '', active: true },
        ]}
        className={cls.BreadCrumbs}
      />
      <h2 className={`title-1 ${cls.Title}`} data-testid="new-tariff-feature-title">
        Add feature
      </h2>
      <CreateOrChangeTariffFeatureForm submitHandler={createFeatureHandler} className={cls.Form} />
    </div>
  );
};

export default NewTariffFeaturePage;
